// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal-wrapper {
  width: 100vw;
  height: 100dvh;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  transform: translate(0);
}
.custom-modal-wrapper .custom-modal-backdrop {
  width: 100vw;
  height: 100%;
  background: var(--black-600);
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
}
.custom-modal-wrapper .custom-modal-box {
  --modal-top-margin: 2rem;
  --modal-bottom-margin: 2rem;
  width: inherit;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--modal-top-margin) 1rem var(--modal-bottom-margin);
  margin: 0 auto;
}
.custom-modal-wrapper .custom-modal {
  width: 100%;
  max-width: 39.375rem;
  max-height: calc(100dvh - (var(--modal-top-margin) + var(--modal-bottom-margin)));
  background-color: var(--white-1000);
  border-radius: 1rem;
  box-shadow: 0px 4px 4px var(--black-250);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 1.5rem;
}
.custom-modal-wrapper .custom-modal .custom-modal-header {
  border-bottom: 1px solid var(--platinum-1000);
  padding: 2rem 1rem 1rem;
  position: relative;
}
.custom-modal-wrapper .custom-modal .custom-modal-header .custom-modal-title-text {
  color: var(--black-1000);
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
}
.custom-modal-wrapper .custom-modal .custom-modal-header .close-btn {
  width: 1.625rem;
  min-width: 1.625rem;
  height: 1.625rem;
  background-color: transparent;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  transition: all 0.2s ease-in-out;
}
.custom-modal-wrapper .custom-modal .custom-modal-header .close-btn svg {
  width: 0.875rem;
  height: 0.875rem;
  fill: var(--black-1000);
  transition: 200ms all ease-in-out;
}
.custom-modal-wrapper .custom-modal .custom-modal-body {
  flex-grow: 1;
  overflow-y: auto;
  padding: 1.25rem 1.25rem 2rem;
}
@media screen and (max-width: 767.98px) {
  .custom-modal-wrapper .custom-modal-box {
    padding: 0;
  }
  .custom-modal-wrapper .custom-modal {
    width: 100%;
    max-width: unset;
    height: 100dvh;
    max-height: unset;
    border-radius: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common_UI_Kit/CustomModal/CustomModalStyle.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;AACF;AACE;EACE,YAAA;EACA,YAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AACJ;AAEE;EACE,wBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gEAAA;EACA,cAAA;AAAJ;AAGE;EACE,WAAA;EACA,oBAAA;EACA,iFAAA;EAGA,mCAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AAHJ;AAKI;EACE,6CAAA;EACA,uBAAA;EACA,kBAAA;AAHN;AAKM;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAHR;AAMM;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gCAAA;AAJR;AAMQ;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iCAAA;AAJV;AASI;EACE,YAAA;EACA,gBAAA;EACA,6BAAA;AAPN;AAWE;EACE;IACE,UAAA;EATJ;EAYE;IACE,WAAA;IACA,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,gBAAA;EAVJ;AACF","sourcesContent":[".custom-modal-wrapper {\n  width: 100vw;\n  height: 100dvh;\n  z-index: 1000;\n  position: fixed;\n  top: 0;\n  left: 0;\n  transform: translate(0);\n\n  .custom-modal-backdrop {\n    width: 100vw;\n    height: 100%;\n    background: var(--black-600);\n    z-index: -1;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  .custom-modal-box {\n    --modal-top-margin: 2rem;\n    --modal-bottom-margin: 2rem;\n    width: inherit;\n    height: inherit;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: var(--modal-top-margin) 1rem var(--modal-bottom-margin);\n    margin: 0 auto;\n  }\n\n  .custom-modal {\n    width: 100%;\n    max-width: 39.375rem;\n    max-height: calc(\n      100dvh - calc(var(--modal-top-margin) + var(--modal-bottom-margin))\n    );\n    background-color: var(--white-1000);\n    border-radius: 1rem;\n    box-shadow: 0px 4px 4px var(--black-250);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    padding-bottom: 1.5rem;\n\n    .custom-modal-header {\n      border-bottom: 1px solid var(--platinum-1000);\n      padding: 2rem 1rem 1rem;\n      position: relative;\n\n      .custom-modal-title-text {\n        color: var(--black-1000);\n        font-size: 2.25rem;\n        font-weight: 700;\n        line-height: 1.4;\n        text-align: center;\n      }\n\n      .close-btn {\n        width: 1.625rem;\n        min-width: 1.625rem;\n        height: 1.625rem;\n        background-color: transparent;\n        border: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        position: absolute;\n        top: 0.75rem;\n        right: 0.75rem;\n        transition: all 0.2s ease-in-out;\n\n        svg {\n          width: 0.875rem;\n          height: 0.875rem;\n          fill: var(--black-1000);\n          transition: 200ms all ease-in-out;\n        }\n      }\n    }\n\n    .custom-modal-body {\n      flex-grow: 1;\n      overflow-y: auto;\n      padding: 1.25rem 1.25rem 2rem;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    .custom-modal-box {\n      padding: 0;\n    }\n\n    .custom-modal {\n      width: 100%;\n      max-width: unset;\n      height: 100dvh;\n      max-height: unset;\n      border-radius: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
